import Modal from './accessibility';

class fixedSidebar {
  constructor(element){
    this.wrapper    = element;
    this.element    = element.querySelector('.fixed_sidebar');
    this.modal      = element.querySelector('.fixed_sidebar__modal');
    this.modalInner = element.querySelector('.fixed_sidebar__modal_inner');
    this.close      = element.querySelector('.fixed_sidebar__close');
    this.triggers   = element.querySelectorAll('.trigger');
    this.bg         = element.querySelector('.fixed_sidebar__modal_bg');
    this.top        = null;
    this.height     = null;
  }
  configure() {
    this.setTop();
    this.setHeight();

    if(!this.element.classList.contains('visible')){
      this.element.classList.add('visible');
    }
  }
  setTop(){
    // Get the position in relation to the entire document
    this.top = this.wrapper.getBoundingClientRect().top + window.pageYOffset;
  }
  setHeight(){
    const entryContent = document.querySelector('.entry-content');
    let bottom = null;

    // Check for any endpoints present on page, below the current sidebar
    const endPoints = document.querySelectorAll('.fixed_sidebar__end, .fixed_sidebar__wrapper');
    if(!!endPoints){
      endPoints.forEach((endPoint) => {
        const endTop = endPoint.getBoundingClientRect().top + window.scrollY;

        // Set Bottom to the top of the first matched endpoint
        if(endTop > this.top && !bottom){
          bottom = endTop;
        }
      });
    }

    // If no bottom was set, set the height to the height of .entry-content minus the top position
    if(!bottom) {
      bottom = entryContent.getBoundingClientRect().top + window.scrollY + entryContent.offsetHeight;
    }

    this.height = bottom - this.top;
    this.wrapper.style.height = Math.ceil(this.height) + 'px';
  }
  openModal(e){
    e.preventDefault();
    this.modal.classList.add('active');
    this.modal.setAttribute('aria-hidden', 'false');

    // Handles trapping focus in modal
    Modal.open(this.modal);
    this.close.setAttribute('tabindex', '1');
    document.querySelector('body').classList.add('scroll-lock');
  }
  closeModal(e){
    e.preventDefault();
    this.close.blur();
    this.triggers[0].focus();
    this.triggers[0].blur();

    this.modal.classList.remove('active');
    this.modal.setAttribute('aria-hidden', 'true');

    // Handles trapping focus in modal
    Modal.close(this.modal);
    document.querySelector('body').classList.remove('scroll-lock');

    // Set the inner content back to the top
    setTimeout(() => {
      this.modalInner.scrollTo(0, 0);
    }, 400);
  }
  fadeModalHeading(){
    const scrollPos = this.modalInner.scrollTop;
    const heading = this.modal.querySelector('.fixed_sidebar__modal_header h2');

    if(scrollPos > 250){
      heading.classList.add('active');
    }
    else {
      heading.classList.remove('active');
    }
  }
}

const sidebars = document.querySelectorAll('.fixed_sidebar__wrapper');

if(sidebars.length){
  sidebars.forEach((el) => {
    const sidebar = new fixedSidebar(el);

    document.addEventListener('pageloaded', () => {
      sidebar.configure();
    });

    let sidebarResize;
    window.addEventListener('resize', () => {
      clearTimeout(sidebarResize);
      sidebarResize = setTimeout(() => {
        sidebar.configure();
      }, 100);
    });

    // Open Modal
    if(sidebar.triggers.length){
      sidebar.triggers.forEach((trigger) => {
        trigger.addEventListener('click', (e) => {
          sidebar.openModal(e);
        });
      });
    }

    // Close Modal
    if(sidebar.close){
      sidebar.close.addEventListener('click', (e) => {
        sidebar.closeModal(e);
      });

      sidebar.bg.addEventListener('click', (e) => {
        sidebar.closeModal(e);
      });
    }

    // Fade modal heading in on scroll
    if(sidebar.modalInner){
      sidebar.modalInner.addEventListener('scroll', () => {
        sidebar.fadeModalHeading();
      });
    }
  });
}
